import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

import { epdmRol } from "./shared.calculation";

export const surfaceArea = (
    widthA1: number,
    heightB1: number,
    lengthC1: number,
    widthW1: number
) => {
    return (
        (widthA1 + heightB1 + lengthC1 + heightB1 + widthA1 + 20) *
        (widthA1 + heightB1 + widthW1 + heightB1 + widthA1 + 20)
    );
};

export const flexifoilSurfaceGlue = (lengthC1: number, widthW1: number) => {
    return Math.ceil(((lengthC1 - 30) * (widthW1 - 30)) / 10_000 / 9);
};

export const flexifoilBordersGlue = (
    lengthC1: number,
    widthW1: number,
    heightB1: number,
    widthA1: number
) =>
    Math.ceil(
        (lengthC1 * widthW1 -
            (lengthC1 - 30) * (widthW1 - 30) +
            2 * (heightB1 * lengthC1 + heightB1 * widthW1) +
            ((widthA1 + lengthC1 + widthA1) * (widthA1 + widthW1 + widthA1) -
                lengthC1 * widthW1)) /
            10_000 /
            2
    );

export const isolationAmount = (lengthC1: number, widthW1: number) =>
    lengthC1 * widthW1;

export const epmd = (
    availableDefaultSizes: Array<{
        size: number;
        product: Product<ProductFieldSet.ProductTile>;
    }>,
    lengthC1: number,
    widthA1: number,
    heightB1: number,
    widthW1: number
) => {
    const width =
        (widthA1 + heightB1 + widthW1 + heightB1 + widthA1 + 20) / 100;

    const length =
        (widthA1 + heightB1 + lengthC1 + heightB1 + widthA1 + 20) / 100;

    return epdmRol(availableDefaultSizes, length, width);
};
